import { Component, ViewChild, TemplateRef, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SearchUsersComponent } from '../../search-users/search-users.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';

@Component({
  selector: 'app-parallel-workflow-oos-actions',
  templateUrl: './parallel-workflow-oos-actions.component.html',
  styleUrls: ['./parallel-workflow-oos-actions.component.scss']
})
export class ParallelWorkflowOosActionsComponent implements OnInit, OnDestroy {

  isProcessing = false;

  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  searchByReviewByUser: any;
  ReviewByUserDropdown: any = [];
  visibleactionperfrom: boolean;
  listOfUsers: any;

  moduleNameForDropdown: any = [];
  documentTypeListDropdown: any = [];
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }
  dateCustomClasses: DatepickerDateCustomClasses[];


  analyserList: any = [];
  reviewerList: any = [];
  approverList: any = [];
  investigationTechniqueList: any = [];

  analyserDropDown: any = [];
  reviewerDropdown: any = [];
  approverDropdown: any = [];
  investigationTechniqueDropDown: any = [];

  analyserSearchText: string = "";
  planReviewerSearchText: string = '';
  planApproverSearchText: string = '';
  investigationTechniqueSearchText: string = '';

  constructor(
    readonly router: Router,
    readonly dialog: MatDialog,
    readonly message: messageService,
    readonly qualityService: qmsService,
    readonly paginationService: PaginationService,

    private readonly elem: ElementRef,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.appService.getOneQmsUsersWithRolesVwDetails("QMS").subscribe((response: any) => {
      for (const element of response) {
        element.isActive = element.isActive == "Y";
      }
      this.listOfUsers = response;
      this.listOfUsers = this.listOfUsers.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      this.selectBoxForUser();
      this.isProcessing = false;
    })

    this.appService.getCodeListsByGroup("DOCUMENT_TYPE").subscribe((data: any) => {
      this.dropDownDataForDocumentType = data;
      this.callSelectBoxValues();
      this.isProcessing = false;
    })

    this.appService.getQmsActiveGroupUsers(this.qualityService.activity.groupId, "OOS", 'Analyser').subscribe((analyser: any) => {
      this.analyserList = analyser;
      this.selectBoxForAnalyser();
    })

    this.appService.getCodeListsByGroup("INVESTIGATION_TECHNIQUE").subscribe((technique: any) => {
      this.investigationTechniqueList = technique;
      this.selectBoxForInvestigationTechnique();
    })

    this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Action Reviewer').subscribe((data: any) => {
      this.reviewerList = data;
      this.selectBoxForReviewer();
    })

    this.appService.getQmsActiveGroupUsers(this.qualityService.selectedGroup, this.qualityService.moduleName, 'Action Approver').subscribe((data: any) => {
      this.approverList = data;
      this.selectBoxForApprover();
    })

    this.getCall();
  };

  selectBoxForAnalyser() {
    this.analyserDropDown = this.analyserList?.map((analyser: any) => ({
      valueExp: analyser.userId,
      displayExp: analyser.userName,
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  selectBoxForReviewer() {
    this.reviewerDropdown = this.reviewerList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onReviewerSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reviewer', item);
    }
  }

  selectBoxForApprover() {
    this.approverDropdown = this.approverList?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onApproverSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('approver', item);
    }
  }

  selectBoxForInvestigationTechnique() {
    this.investigationTechniqueDropDown = this.investigationTechniqueList?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    }))?.sort((m: { displayExp: any }, n: { displayExp: any }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'initial-complaint-category-validation' || fieldId === 'final-complaint-category-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  dropDownDataForDocumentType: any;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  popupTitle: any;
  parallelWorkflowActionObj: any = {};

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };

  callSelectBoxValues() {
    this.selectBoxForDesignation();
    this.selectBoxForDepartment();
  }

  selectBoxForDesignation() {
    this.designationCodeDropdown = this.dropDownForDesignationCode?.map((designation: any) => ({
      valueExp: designation.codelistCode,
      displayExp: designation.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  selectBoxForUser() {
    this.listOfUsersDropdown = this.listOfUsers?.map((user: any) => ({
      valueExp: user.userId,
      displayExp: user.userName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  };

  selectBoxForDepartment() {
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((dept: any) => ({
      valueExp: dept.codelistCode,
      displayExp: dept.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  openAddPopup() {
    this.parallelWorkflowActionObj = {};
    this.parallelWorkflowActionObj.actionDescription = ''
    this.searchByDepartmentCode = null;
    this.visibleEditButton = false;
    this.popupTitle = "Create Action";
    this.qualityService.getQmsActionDataUsingById = {};
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  };

  visibleEditButton: boolean;
  getQmsBusinessAreaDetail: any;
  isAdenabled: boolean = false;
  assignedUserTxt: any;
  departmentCodeTxt: any;
  listOfUsersDropdown: any;
  searchByDepartmentCode: any = null;
  selectedDepartmentValue: any;
  selectedDesignationValue: any;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];

  openEditPopup(data: any, id: any) {
    if (id == 0 || id == 1) {
      this.isProcessing = true;
      this.parallelWorkflowActionObj = {};
      this.appService.getWorkflowOOSActionsByActionId(this.qualityService.workflowId, data.ACTION_ID).subscribe((data: any) => {
        data.actionPerformed = data.actionPerformed == "Y";
        this.parallelWorkflowActionObj = data;
        if (this.parallelWorkflowActionObj.targetDate) {
          this.parallelWorkflowActionObj.targetDate = new Date(this.parallelWorkflowActionObj.targetDate);
        } else {
          this.parallelWorkflowActionObj.targetDate = null;
        }


        this.popupTitle = "Update Action";

        if (data.assignedToDepartment != '' && data.assignedToDepartment != undefined && data.assignedToDepartment != null) {
          let departmentCodeValues = this.dropDownForDepartmentCode.filter((x: any) => x.codelistCode === data.assignedToDepartment);
          if (departmentCodeValues.length > 0) {
            this.searchByDepartmentCode = departmentCodeValues.codelistCode;
          }
        }

        this.visibleEditButton = true;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        this.isProcessing = false;
      });
    }
  };

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDepartmentValue = item.valueExp;
      }
    }
  }

  onDepartmentCodeRemoved(item: any) { };

  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDesignationValue = item.valueExp;
      }
    }
  }

  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
    maxDate: new Date(this.qualityService.activity.expcetedClosureOn),
  }


  mandatoryValidation(elementIds: any) {
    elementIds.forEach((elementId: any) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    })
  }


  addAndEditFunction(action: any) {

    const validations: any = [];

    validations.push(
      { condition: !this.parallelWorkflowActionObj.actionName, id: 'actionName-validation' },
      { condition: !this.parallelWorkflowActionObj.targetDate, id: 'targetDate-validation' },
      { condition: !this.parallelWorkflowActionObj.assignedToUser, id: 'assignedTo-validation' }
    )

    const invalidIds = validations.filter((validation: any) => validation.condition).map((validation: any) => validation.id);

    if (invalidIds.length > 0) {
      this.mandatoryValidation(invalidIds);
      this.showSnackBar('Please enter all mandatory fields', 'E');
    } else {
      this.isProcessing = true;

      let phase = ''
      if (this.qualityService.activity.phaseIIInvestigationReqd) phase = 'II';
      else if (this.qualityService.activity.phaseIIIInvestigationReqd) phase = 'III';
      else phase = 'I';

      const obj = {
        workflowId: this.qualityService.workflowId,
        oosNo: this.qualityService.activityId,
        actionName: action.actionName,
        actionDescription: action.actionDescription,
        responsibleDepartment: action.responsibleDepartment,
        investigationType: action.investigationType,
        assignedToUser: action.assignedToUser,
        assignedToDepartment: action.assignedToDepartment,
        targetDate: this.appService.dateZoneConvertion(new Date(action.targetDate)),
        investigationPlan: action.investigationPlan,
        planNoOfAnalyst: action.planNoOfAnalyst,
        analysedBy: action.analysedBy,
        investigationTool: action.investigationTool,
        comments: action.comments,
        justification: action.justification,
        actionPlanReviewer: action.actionPlanReviewer,
        actionPlanApprover: action.actionPlanApprover,
        phase: phase
      }

      if (this.visibleEditButton) {
        const modifiedObj = { ...obj, actionId: action.actionId, slNo: action.slNo }

        this.appService.updateWorkflowOosActions(modifiedObj).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.appService.createWorkflowOosActions(obj).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  };

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  };

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  deleteReasonFieldValue: any;
  deleteFiledValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  workflowId: number = 0;
  actionId: any;
  oosNo: any;
  deleteReason: any = null;
  deleteCodelist(deletingData: any) {
    this.popupTitle = "Delete Action";
    this.workflowId = deletingData.WORKFLOW_ID;
    this.actionId = deletingData.ACTION_ID;
    this.oosNo = deletingData.OOS_NO;
    this.deleteReason = null;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  deleteFunction(deletingData: any) {
    if (this.deleteReason) {
      this.isProcessing = true;

      const deleting_obj = {
        workflowId: this.workflowId,
        actionId: this.actionId,
        oosNo: this.oosNo,
        deleteReason: this.deleteReason,
      }

      this.appService.deleteWorkflowOosActions(deleting_obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDelete() {
    this.visibleDeletePopup.close();
  }

  idMapping: Record<string, string> = { 'CR': this?.qualityService?.activity?.crId, 'CAPA': this.qualityService.activity.capaId, 'DV': this.qualityService.activity.dvId, 'IN': this.qualityService.activity.inId, 'QI': this.qualityService.activity.qiId, 'CC': this.qualityService.activity.ccId };
  auditTrail: any = {};
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, action: any) {
    let actionName;

    if (action) {
      if (action.ACTION_NAME.length > 20) {
        actionName = action.ACTION_NAME.slice(0, 20) + '...';
      } else {
        actionName = action.ACTION_NAME;
      }
    } else {
      actionName = 'OverAll';
    }
    this.auditTrail.oosNo = viewType == 'overAll' ? null : action.ACTION_ID;
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityoosNo = this.message.activityId;
    this.auditTrail.gridName = 'WORKFLOW_OOS_ACTIONS';
    this.auditTrail.report_And_Popup_Name = this.qualityService.moduleName + ' Parallel Workflow OOS Actions Audit Trail [' + this.idMapping[this.qualityService.moduleName] + (viewType === 'overAll' ? '' : ' - ' + actionName) + ']';
    this.dynamicAuditTrailComponent.triggerTrail(action);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qualityService.moduleName + '  Parallel Workflow OOS Actions Report [' + this.idMapping[this.qualityService.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qualityService.moduleName, 0)
  }

  onChildValueEmit() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  getDynamicLabel() {
    this.isProcessing = true;
    const data = {
      tableName: this.gridObj.tableOrViewName,
      moduleName: this.qualityService.moduleName,
      gridName: this.gridObj.gridName,
      groupId: this.qualityService.selectedGroup,
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  searchAssignTo(workingFor: string) {
    this.searchUsersComponent.popupTitle = 'Assign To';
    this.searchUsersComponent.isSwitchingUser = workingFor == 'switch';
    this.searchUsersComponent.isSwitchingUser && (this.message.switchUserCurrentValue = this.parallelWorkflowActionObj.assignedToUser);
    this.searchUsersComponent.selectionMode = 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    this.parallelWorkflowActionObj.assignedToUser = this.qualityService.selectedSearchUserId;
    this.parallelWorkflowActionObj.assignedTo = this.qualityService.selectedSearchUserName;
    if (this.searchUsersComponent.isSwitchingUser) {
      this.addAndEditFunction(this.parallelWorkflowActionObj);
    }
  }

  grid: any = [];
  gridTemp: any = [];
  selectedGridData: any = [];
  gridObj: any = {};

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  parentCheckBox: boolean = false;

  getCall() {
    this.isProcessing = true;
    this.selectedGridData = [];
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "WORKFLOW_OOS_ACTIONS",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          workflowId: this.qualityService.workflowId,
        }
        this.gridObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.getDynamicLabel()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  onParentChanged(e: any) {
    if (e.target.checked) {
      this.selectedGridData = this.pagedItems.length == 10 ? this.grid : this.pagedItems;

      for (const element of this.grid) { element.childCheckBox = true }
    } else {

      this.selectedGridData = [];
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.selectedGridData?.some((copied: any) => copied.TEMPLATE_ID === checked.TEMPLATE_ID)) {
      this.selectedGridData.push(checked);
    }

    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  onChildUnchecked(unchecked: any) {
    this.selectedGridData = this.selectedGridData?.filter((copied: any) => copied.TEMPLATE_ID !== unchecked.TEMPLATE_ID);
  }

  refreshGrid() {
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };
  config: EditorConfig = {
    //placeholder: 'Type something...',
    buttons: [],
    // height: '100px',
  };
  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Action Description': this.dynamicLabel?.['ACTION_DESCRIPTION']?.fieldName,
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qualityService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qualityService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };


  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  public focusEmpty(): void {
    console.log();
  }
}
